import orderBy from 'lodash/orderBy'
import moment from 'moment'
import { compact } from 'lodash'
import config, { getLabelForCountry } from '@/config'

const DEFAULT_BANK_ACCOUNT = {
  accountHolder: '',
  iban: '',
  bic: '',
}

const getBirthDay = (birthday) => {
  if (!birthday) return null

  return moment(birthday).isValid()
    ? moment(birthday).format(config.dateFormat.api)
    : moment(birthday, config.dateFormat.client).format(config.dateFormat.api)
}

const getContactPersons = (contactPersons = []) => {
  const orderedContactPersons = orderBy(contactPersons, ['isMainContact'], ['desc'])
  return orderedContactPersons.map((contactPerson, index) => ({
    ...contactPerson,
    birthday: getBirthDay(contactPerson.birthday),
    tempId: index + 1,
  }))
}

const getMapData = (addressToParse = {}) => {
  const { label: country } = getLabelForCountry(addressToParse.countryIso)
  const address = compact([addressToParse.street, addressToParse.zipCode, addressToParse.city, country])
  const subHeadingZipCity = compact([addressToParse.zipCode, addressToParse.city]).join(' ')
  let subHeading = subHeadingZipCity && country ? `${subHeadingZipCity}, ${country}` : ''
  subHeading = subHeading || subHeadingZipCity || country

  return {
    showMap: address.join('').length > 0,
    heading: addressToParse.street,
    subHeading,
    mapAddress: address.join(', '),
  }
}

const getWebsiteLink = (url) => {
  if (/https?:\/\//.test(url)) {
    return url
  }

  return `https://${url}`
}

export default class SupplierModel {
  constructor(data = {}) {
    this.id = data.id || undefined
    this.name = data.name || ''
    this.addresses = data.addresses
      ? data.addresses.map((address, index) => ({ ...address, tempId: index + 1 })) // + 1 because 0 is falsy
      : []
    this.email = data.email || ''
    this.website = data.website || ''
    this.websiteLink = getWebsiteLink(data.website)
    this.phone1 = data.phone1 || ''
    this.phone2 = data.phone2 || ''
    this.mobile = data.mobile || ''
    this.fax = data.fax || ''
    this.customerReference = data.customerReference || ''
    this.contactPersons = getContactPersons(data.contactPersons)
    this.bankAccounts = data.bankAccounts || [DEFAULT_BANK_ACCOUNT]
    this.discount = data.discount || 0.00
    this.notes = data.notes || ''
    this.notesAlert = data.notesAlert || false
    this.aliases = data.aliases || []
    this.kind = 'supplier'
    this.mapData = getMapData(data?.addresses && data.addresses[0])
    this.tags = data.tags || []
    this.defaultBookkeepingAccountId = data.defaultBookkeepingAccountId || undefined
    this.accountNo = data.accountNo || undefined
    this.payKindId = data.payKindId || undefined
    this.cashDiscountSetting = data.cashDiscountSetting || {}
    this.discountEnabled = data.discountEnabled || false
    this.vatId = data.vatId || ''
    this.number = data.number || undefined

    if (data.bankAccounts && data.bankAccounts?.length) {
      const { accountHolder, iban, bic } = data.bankAccounts[0]
      this.accountHolder = accountHolder || data.name
      this.iban = iban
      this.bic = bic
    }
  }
}
